<template>
  <section>
    <router-view />
  </section>
</template>

<script lang="ts" setup></script>
